<template>
  <div>
    <transition name="fade">
      <div class="alert alert-success" v-if="hasSuccessMessage">
        {{ message }}
      </div>
      <div class="alert alert-danger" v-if="hasErrorMessage">
        {{ message }}
      </div>
      <div class="alert alert-warning" v-if="hasWarningMessage">
        {{ message }}
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'notification',
  data: function () {
    return {
      timeout: null,
      exceptions: ['success.register', 'errors.project_cancelled', 'errors.product_out_of_range',
        'errors.stock_exhausted', 'errors.stock_exhausted_overview', 'errors.customers_private',
        'messages.order_thanks_open', 'messages.order_thanks_paid', 'errors.order_thanks']
    }
  },
  computed: {
    hasSuccessMessage: function () {
      return this.$store.state.type === 'success'
    },
    hasErrorMessage: function () {
      return this.$store.state.type === 'error'
    },
    hasWarningMessage: function () {
      return this.$store.state.type === 'warning'
    },
    message: function () {
      return this.$i18n.t(this.$store.state.message)
    }
  },
  watch: {
    message: function () {
      clearTimeout(this.timeout)

      let store = this.$store
      let total = this.exceptions.filter(function (exception) {
        return exception === store.state.message
      }).length
      if (total === 0) {
        this.timeout = setTimeout(function () {
          store.commit('clear')
        }, 2000)
      }
    }
  }
}
</script>

<style scoped>
  .alert {
    margin: 10px;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Notification.vue